import React from 'react'
import Temp from "./components/Temp"
const App = () => {
  return (
    <Temp />
  )
}

export default App